import { Component, Input } from '@angular/core';

@Component({
  selector: 'loader-spin',
  templateUrl: './loader-spin.component.html',
  styleUrls: ['./loader-spin.component.scss']
})
export class LoaderSpinComponent {

  // Input
  @Input() label: string = '';

  // Constructor
  constructor() { }

}



// WEBPACK FOOTER //
// ./src/app/shared/components/loader-spin/loader-spin.component.ts